// WhatsAppIcon.tsx — replace the entire component with this:
"use client";
import { MessageCircle } from "lucide-react";
import { useAppSelector } from "../../_hooks/hooks";

const WhatsAppIcon = () => {
  const WhatsAppNo = useAppSelector((state) =>
    state.home.SettingList?.find((s: any) => s.SettingKey === "WhatsAppNo")?.SettingValue
  );

  const phone = WhatsAppNo ? WhatsAppNo.replace(/\D+/g, "") : "";
  const whatsappLink = phone
    ? `https://wa.me/${phone}?text=${encodeURIComponent("Hello, I'd like to know more details.")}`
    : "#";

  // Always render — never return null — prevents CLS
  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-15 right-4 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all duration-300 hover:shadow-green-500/50 group w-[60px] h-[60px] flex items-center justify-center notranslate"
      translate="no"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 group-hover:rotate-12 transition-transform" />
    </a>
  );
};

export default WhatsAppIcon;